import { render, staticRenderFns } from "./VerLocalizaciones.vue?vue&type=template&id=aaf52450"
import script from "./VerLocalizaciones.vue?vue&type=script&lang=js"
export * from "./VerLocalizaciones.vue?vue&type=script&lang=js"
import style0 from "./VerLocalizaciones.vue?vue&type=style&index=0&id=aaf52450&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports